<template>
    <div class="turquoise-created-alert">
        <button @click.prevent="close" class="close" aria-label="Close">
            <SvgsClose />
        </button>
        <div>
            <h2 class="turquoise-alert-headline">
                "<span>{{ siteNames.toString() }}</span>" Removed from
                <span class="list-name">{{ listName }}</span>
            </h2>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        siteNames: {
            type: Array,
            required: true,
            default: [],
        },
        listName: {
            type: String,
            required: true,
            default: '',
        },
    });
    const { siteNames, listName } = toRefs(props);

    const emit = defineEmits(['closeRemovedSiteAlert']);
    function close() {
        emit('closeRemovedSiteAlert');
    }

    onMounted(() => {
        setTimeout(() => {
            close();
        }, 3000);
    });
</script>

<style lang="scss" scoped>
    .turquoise-created-alert {
        z-index: $zStepFour;
        position: absolute;
        top: 15px;
        right: 15px;
        left: 15px;
        padding: 30px;
        background-color: $turquoise;

        text-align: center;

        .turquoise-alert-headline {
            margin-bottom: 10px;
            font-weight: 400;

            .list-name {
                font-weight: 800;
            }
        }

        .close {
            position: absolute;
            top: 10px;
            right: 15px;
        }
    }

    .default {
        .turquoise-created-alert {
            position: fixed;
        }
    }
</style>
